export const contextValueOptions = [50, 100, 150, 300, 500] as const;
export const defaultContextValue = contextValueOptions[1];
